export enum PhoneCallEventDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}
